const getters = {
  sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  hasGotRouters: state => state.permission.hasGotRouters,
  menuData: state => state.permission.menuData,
  appList: state => state.permission.appList,
  domain: state => state.permission.domain
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js